export const AppState = {
	ENABLED  : 'enabled',
	DISABLED : 'disabled',
	LOADING  : 'loading',
	PROBLEM  : 'problem',
};
